import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, isMemoSame as _isMemoSame, withMemo as _withMemo, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo/like.svg'
import _imports_1 from '@/assets/img/logo/location.svg'


const _withScopeId = n => (_pushScopeId("data-v-0acd9efa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col min-h-screen relative" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-x-3 lg:gap-x-5 xl:gap-x-7 gap-y-3 xl:gap-y-5 2xl:gap-y-8 search-results sm:px-0 px-4" }
const _hoisted_4 = { class: "img-container mb-3 md:mb-3.5" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 0,
  class: "absolute top-0 w-full h-full rounded-md flex justify-center items-center text-white"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-full bg-black opacity-40 rounded-md" }, null, -1))
const _hoisted_8 = { class: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-medium" }
const _hoisted_9 = { class: "w-full h-full overflow-hidden px-0 sm:px-0" }
const _hoisted_10 = { class: "text-xs text-sub" }
const _hoisted_11 = { class: "h-12 pr-2 pt-2 line-clamp-2 text-sm text-heading text-def" }
const _hoisted_12 = { class: "font-semibold space-s-2 mt-0.5 text-heading lg:text-lg lg:mt-1.5 text-def tracking-wide" }
const _hoisted_13 = { class: "text-xs text-sub flex space-x-2 pt-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "mr-1"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "mr-1"
}, null, -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "w-full pt-20 justify-center items-start flex" }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "w-full justify-center pt-10 items-center flex" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-40" }, null, -1))

import { ref, watch, onMounted, computed, } from 'vue';
// import { SearchApi } from '@/api/api';
import { formattedPrice, splitLocation } from '@/utils/formattedUnit';
import { timeForToday } from '@/utils/timeForToday';
import useIntersectionObserver from '@/utils/useIntersectionOvserver';
import LoadingCircle from '@/components/UI/LoadingCircle.vue'
import NoResult from '@/components/Serach/NoResult.vue'
import ShowMorph from './ShowMorph.vue';
import ScrollTopBtn from '@/components/UI/ScrollTop.vue'
import DimmedLoading from '../UI/DimmedLoadingV2.vue';
import { encodeBase62 } from '@/utils/idConverter';

import { debounce } from 'lodash';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { isTokenValid } from '@/utils/Functions';
interface Item {
    id: number;
    title: string;
    name: string;
    imgURL1: string;
    content: string;
    price: number;
    create_at: string;
    location: string;
    like_cnt: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchList',
  setup(__props) {

const router = useRouter();
const store = useStore();

const { elementRef: loaderRef, isVisible } = useIntersectionObserver({});

const clickedItem = ref<Item | null>(null); 
const isRendered = ref<Boolean>(false);
const aLoading = ref(false); // 전체리스트 로딩
// const categoryLoading = ref<Boolean>(false);

const currentList = computed(() => store.state.currentList);
const currentStatus = computed(()=> store.state.currentStatus);
// const currentList = ref([]);
const categoryName = computed(()=> store.state.selectedSpecies);
// const categoryName = computed(()=> store.getters.getSelectedSpecies);
// const isCaLoading = computed(() => store.state.categories[categoryName.value].hasMoreData)

const categories = computed(() => store.getters.getCategories);
const filterResult = computed(() => store.state.filterResult);
const isLoading = computed(() => store.state.isLoading);
const noResult = computed(() => store.state.noResult);
// const isCategoryLoading = computed(() => {
//     const categoryData = store.state.categories[categoryName.value];
//     return categoryData ? categoryData.hasMoreData : 'aa';
// });
// const allCursor = computed(() => store.state.allCursor)

// const reptileList = computed(() => store.getters.getReptileList);

// 처음 접속 시, 전체 리스트를 출력함
onMounted(async () => {
    // if(!isRendered.value) return;
    if(currentList.value.length === 0 && !noResult.value){
        await store.dispatch('getReptileList');
        isRendered.value = true

    }

})
// const debouncedLoadReptileList = debounce(async () => {
//     console.log('호출')
//     aLoading.value = true;
//     await store.dispatch('getReptileList');
//     aLoading.value = false;
// }, 500);

const loadReptileList = async () => {
    aLoading.value = true;
    // await store.dispatch('getReptileList');

    await new Promise<void>(resolve => {
        setTimeout(() => {
            store.dispatch('getReptileList');
        aLoading.value = false;

            resolve();
        }, 500);
    });
    // aLoading.value = false;

};


const loadCategoryList = async () => {
    const categoryLoading = (categories.value[categoryName.value].hasMoreData);
    if(categoryLoading){
        aLoading.value = true;

        await new Promise<void>(resolve => {
            setTimeout(() => {
                store.dispatch('fetchCategoryData', categoryName.value);
                resolve();
            }, 500);
        });
        aLoading.value = false;
    }
};
const loadHamburgerList = async () => {
    const categoryLoading = (categories.value[categoryName.value].hasMoreData);
    if(categoryLoading){
        aLoading.value = true;

        await new Promise<void>(resolve => {
            setTimeout(() => {
                store.dispatch('fetchHamburgerData', categoryName.value);
                resolve();
            }, 500);
        });
        aLoading.value = false;
    }
};
const loadFilterList = async () => {
    const FilterLoading = (filterResult.value.hasMoreData)

    if(FilterLoading){
        aLoading.value = true;

        await new Promise<void>(resolve => {
            setTimeout(() => {
                store.dispatch('fetchFilterData');
                resolve();
            }, 500);
        });
        aLoading.value = false;

    }

};


watch(isVisible, debounce((newVal) => {
    // if(!isLoading.value){
        // console.log('loading')
        if (currentStatus.value === 0 && newVal ) {
            loadReptileList();
        // await loadReptileList();
        }
        if (currentStatus.value === 1 && newVal) {
             loadCategoryList();
        }
        if (currentStatus.value === 2 && newVal) {
             loadFilterList();
        }
        if (currentStatus.value === 3 && newVal) {
             loadHamburgerList();
        }
    // } else {
    //     return;
    // }
    }, 200));
// watch(isVisible, async (newVal) => {
//     // if(!isLoading.value){
//         // console.log('loading')
//         if (currentStatus.value === 0 && newVal ) {
//         await loadReptileList();
//         }
//         if (currentStatus.value === 1 && newVal) {
//             await loadCategoryList();
//         }
//         if (currentStatus.value === 2 && newVal) {
//             await loadFilterList();
//         }
//         if (currentStatus.value === 3 && newVal) {
//             await loadHamburgerList();
//         }
//     // } else {
//     //     return;
//     // }
// });

// 상세보기 
const postDetail = (item :Item) => {
    clickedItem.value = item;
    router.push({ path: `reptile/${encodeBase62(item.id)}` });
};




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ShowMorph, { class: "sm:px-0 px-4" }),
    _createElementVNode("div", _hoisted_1, [
      (noResult.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(NoResult)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentList.value, (item, __, ___, _cached) => {
          const _memo = ([item.id])
          if (_cached && _cached.key === item.id && _isMemoSame(_cached, _memo)) return _cached
          const _item = (_openBlock(), _createElementBlock("li", {
            key: item.id,
            onClick: ($event: any) => (postDetail(item)),
            class: "group box-border overflow-hidden flex rounded-md cursor-pointer pe-0 pb-2 lg:pb-3 flex-col items-start transition duration-200 ease-in-out transform shadow-product bg-white liWrap relative"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: `${(item.imgURL1)}`,
                alt: item.title,
                class: "bg-gray-300 object-cover w-full transition duration-200 ease-in rounded-md"
              }, null, 8, _hoisted_5),
              (item.del_flag === 9 || item.del_flag === 7)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, _toDisplayString(item.del_flag === 9 ? '판매완료' : '예약중'), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(item.name) + " · " + _toDisplayString(_unref(timeForToday)(item.create_at)), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(formattedPrice)(item.price)) + "원 ", 1),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(item.like_cnt) + " ", 1),
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(_unref(splitLocation)(item.location)), 1)
              ])
            ])
          ], 8, ["onClick"]))
          _item.memo = _memo
          return _item
        }, _cache, 0), 128))
      ]),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(DimmedLoading)
            ])
          ]))
        : (aLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(LoadingCircle)
              ])
            ]))
          : _createCommentVNode("", true)
    ]),
    _createVNode(ScrollTopBtn),
    _createElementVNode("div", {
      ref_key: "loaderRef",
      ref: loaderRef,
      class: "w-full h-20 justify-center items-center flex"
    }, null, 512),
    _hoisted_20
  ], 64))
}
}

})